import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  cleanTechnologiesPaginatedS,
  startSearchingTechnologiesPaginated,
  technologyCleanSearchText,
  technologySetSearchText,
} from "../../app/actions/technologyActions";
import { cleanSearchingUsersPaginated, startSearchingUsersPaginated, userCleanSearchText, userSetSearchText } from "../../app/actions/userActions";
import { useTranslation } from "react-i18next";
import { alternativeCleanSearchText, alternativeSetSearchText, cleanAlternativesPaginatedS, startSearchingAlternativesPaginated } from "../../app/actions/alternativeActions";
import { assistanceCleanSearchText, assistanceSetSearchText, cleanAssistancesPaginatedS, startSearchingAssistancesPaginated } from "../../app/actions/assistanceActions";
import { cleanExperiencesPaginatedS, experienceSetSearchText, startSearchingExperiencesPaginated } from "../../app/actions/experienceActions";
import { cleanFinancialsPaginatedS, financialSetSearchText, startSearchingFinancialsPaginated } from "../../app/actions/financialActions";
import { cleanInnovationsPaginatedS, innovationCleanSearchText, innovationSetSearchText, startSearchingInnovationsPaginated } from "../../app/actions/innovationActions";
import { cleanRegulationsPaginatedS, regulationCleanSearchText, regulationSetSearchText, startSearchingRegulationsPaginated } from "../../app/actions/regulationActions";
import { cleanVisionsPaginatedS, startSearchingVisionsPaginated, visionCleanSearchText, visionSetSearchText } from "../../app/actions/visionActions";

const SearchBack = ({ searchText, setSearchText, itemsPerPage, module }) => {

  const [searchTextLocal, setSearchTextLocal] = useState("");

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const onChangeInput = (event) => {
    
    setSearchText(event.target.value);
    setSearchTextLocal(event.target.value);

    if (event.target.value !== "") {
      if (module === "technology") {

        dispatch(technologySetSearchText(event.target.value));

      } else if (module === "alternative") {

        dispatch(alternativeSetSearchText(event.target.value));

      } else if (module === "experience") {

        dispatch(experienceSetSearchText(event.target.value));

      } else if (module === "innovation") {

        dispatch(innovationSetSearchText(event.target.value));

      } else if (module === "assistance") {

        dispatch(assistanceSetSearchText(event.target.value));

      } else if (module === "financial") {

        dispatch(financialSetSearchText(event.target.value));

      } else if (module === "vision") {

        dispatch(visionSetSearchText(event.target.value));

      } else if (module === "regulation") {

        dispatch(regulationSetSearchText(event.target.value));

      } else if (module === "User") {
        dispatch(userSetSearchText(event.target.value));

      } else if (module === "Ciiu") {
      }

    } else {
      
      if (module === "technology") {

        dispatch(cleanTechnologiesPaginatedS());
        dispatch(technologyCleanSearchText());

      } else if (module === "alternative") {

        dispatch(cleanAlternativesPaginatedS());
        dispatch(alternativeCleanSearchText());

      } else if (module === "experience") {

        dispatch(cleanExperiencesPaginatedS());
        dispatch(experienceSetSearchText());

      } else if (module === "innovation") {

        dispatch(cleanInnovationsPaginatedS());
        dispatch(innovationCleanSearchText());

      } else if (module === "assistance") {

        dispatch(cleanAssistancesPaginatedS());
        dispatch(assistanceCleanSearchText());

      } else if (module === "financial") {

        dispatch(cleanFinancialsPaginatedS());
        dispatch(assistanceCleanSearchText());

      } else if (module === "vision") {

        dispatch(cleanVisionsPaginatedS());
        dispatch(visionCleanSearchText());

      } else if (module === "visionL1") {

        dispatch(cleanVisionsPaginatedS());
        dispatch(visionCleanSearchText());

      } else if (module === "regulation") {

        dispatch(cleanRegulationsPaginatedS());
        dispatch(regulationCleanSearchText());

      } else if (module === "User") {
        
        dispatch(cleanSearchingUsersPaginated());
        dispatch(userCleanSearchText());
      } else if (module === "Ciiu") {
      }
    }
  };

  const handleGetSearchInformation = (e) => {
    
    e.preventDefault();

    if (searchTextLocal !== "") {
      if (module === "technology") {

        dispatch(startSearchingTechnologiesPaginated(searchTextLocal, 0, itemsPerPage));

      } else if (module === "alternative") {

        dispatch(alternativeSetSearchText(searchTextLocal));
        dispatch(startSearchingAlternativesPaginated(searchTextLocal, 0, itemsPerPage));

      } else if (module === "experience") {

        dispatch(experienceSetSearchText(searchTextLocal));
        dispatch(startSearchingExperiencesPaginated(searchTextLocal, 0, itemsPerPage));

      } else if (module === "innovation") {

        dispatch(innovationSetSearchText(searchTextLocal));
        dispatch(startSearchingInnovationsPaginated(searchTextLocal, 0, itemsPerPage));

      } else if (module === "assistance") {

        dispatch(assistanceSetSearchText(searchTextLocal));
        dispatch(startSearchingAssistancesPaginated(searchTextLocal, 0, itemsPerPage));

      } else if (module === "financial") {

        dispatch(financialSetSearchText(searchTextLocal));
        dispatch(startSearchingFinancialsPaginated(searchTextLocal, 0, itemsPerPage));

      } else if (module === "vision") {

        dispatch(visionSetSearchText(searchTextLocal));
        dispatch(startSearchingVisionsPaginated(searchTextLocal, 0, itemsPerPage));

      } else if (module === "regulation") {

        dispatch(regulationSetSearchText(searchTextLocal));
        dispatch(startSearchingRegulationsPaginated(searchTextLocal, 0, itemsPerPage));

      } else if (module === "User") {
        dispatch(userSetSearchText(searchTextLocal));
        dispatch(startSearchingUsersPaginated(searchTextLocal, 0, itemsPerPage));
      } else if (module === "Ciiu") {
      }

    } else {
      
      if (module === "technology") {

        dispatch(cleanTechnologiesPaginatedS());
        dispatch(technologyCleanSearchText());

      } else if (module === "alternative") {

        dispatch(cleanAlternativesPaginatedS());
        dispatch(alternativeCleanSearchText());

      } else if (module === "experience") {

        dispatch(cleanExperiencesPaginatedS());
        dispatch(experienceSetSearchText());

      } else if (module === "innovation") {

        dispatch(cleanInnovationsPaginatedS());
        dispatch(innovationCleanSearchText());

      } else if (module === "assistance") {

        dispatch(cleanAssistancesPaginatedS());
        dispatch(assistanceCleanSearchText());

      } else if (module === "financial") {

        dispatch(cleanFinancialsPaginatedS());
        dispatch(assistanceCleanSearchText());

      } else if (module === "vision") {

        dispatch(cleanVisionsPaginatedS());
        dispatch(visionCleanSearchText());

      } else if (module === "visionL1") {

        dispatch(cleanVisionsPaginatedS());
        dispatch(visionCleanSearchText());

      } else if (module === "regulation") {

        dispatch(cleanRegulationsPaginatedS());
        dispatch(regulationCleanSearchText());

      } else if (module === "User") {
        
        dispatch(cleanSearchingUsersPaginated());
        dispatch(userCleanSearchText());
      } else if (module === "Ciiu") {
      }
    }
  };

  return (
    <div className="row height d-flex justify-content-center align-items-center">
      <div className="col-md-8">
        <div className="search">
          <i className="fa fa-search"></i>
          <input
            type="text"
            className="form-control"
            placeholder={t("general.option_search")}
            value={searchText}
            id="searchText"
            name="searchText"
            onChange={onChangeInput}
          ></input>
        </div>
      </div>
      <div className="col-md-1">
        <button className="btn btn-secondary" onClick={handleGetSearchInformation}>
          <i className="fa fa-search"></i>
        </button>
      </div>

    </div>
  );
};

export default SearchBack;
